/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : sideBarData.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import SettingsIcon from "../../assets/sidebarIcons/settings.png";
import TestCasesIcon from "../../assets/sidebarIcons/testcase2.png";
import ProjectConfiguratorIcon from "../../assets/sidebarIcons/project_config.png";
import LegalRequirementIcon from "../../assets/sidebarIcons/legal_req1.png";
import VirtualLabCarIcon from "../../assets/sidebarIcons/virtual_labcar.png";
import TypeAppovalIcon from "../../assets/sidebarIcons/regulatory_compliance1.png";
import APIDocIcon from "../../assets/sidebarIcons/document_lib.png";
import { PieSliceIcon } from "./DashboardIcon";
const styles = {
  width: "25px",
  height: "25px",
};

export const sideBarData = [
  {
    title: "Dashboard",
    path: "/dashboard/home",
    icon: <PieSliceIcon />,
  },
  {
    title: "Project Configurator",
    path: "/dashboard/project-config",
    icon: <img alt="pc" src={ProjectConfiguratorIcon} style={styles} />,
  },
  {
    title: "Virtual Lab-Car",
    path: "/dashboard/v2/*",
    icon: <img alt="vlc" src={VirtualLabCarIcon} style={styles} />,
    subItems: [
      {
        title: "Vehicle Systems",
        path: "/dashboard/v2/vehicle-systems",
      },
      {
        title: "EE Architecture ",
        path: "/dashboard/v2/EESWM",
      },
      {
        title: "Linked Components",
        path: "/dashboard/v2/link",
      },
      {
        title: "Mind Map",
        path: "/dashboard/v2/mindmap",
      },
    ],
  },
  {
    title: "Legal Requirements",
    path: "/dashboard/legal-requirements",
    icon: <img alt="legal" src={LegalRequirementIcon} style={styles} />,
    subItems: [
      {
        title: "Requirements",
        path: "/dashboard/legal-requirements",
      },

      {
        title: "Tables",
        path: "/dashboard/legal-tables",
      },
      {
        title: "Rule Center",
        path: "/dashboard/rule-center",
      },
    ],
  },
  {
    title: "Test Cases",
    path: "/dashboard/test-cases",
    icon: <img alt="um" src={TestCasesIcon} style={styles} />,
    subItems: [
      {
        title: "Repository",
        path: "/dashboard/test-cases/repository",
      },
      {
        title: "Campaigns",
        path: "/dashboard/test-cases/campaign",
      },
    ],
  },

  {
    title: "Type Approvals",
    path: "/dashboard/type-approval",
    icon: <img alt="ta" src={TypeAppovalIcon} style={styles} />,
    subItems: [
      {
        title: "Link & Unlink",
        path: "/dashboard/v2/type-approval/link",
      },
      {
        title: "Intersection",
        path: "/dashboard/v2/type-approval/intersection",
      },
      {
        title: "Tickets",
        path: "/dashboard/v2/type-approval/tickets",
      },
    ],
  },

  {
    title: "Document Library",
    path: "/dashboard/doc_library",
    icon: <img alt="ad" src={APIDocIcon} style={styles} />,
    subItems: [
      {
        title: "Reports",
        path: "/dashboard/doc_library/reports",
      },
      {
        title: "Simulation File",
        path: "/dashboard/doc_library/stimulation",
      },
    ],
  },
  {
    title: "Settings",
    path: "/dashboard/admin-settings",
    icon: <img alt="as" src={SettingsIcon} style={styles} />,
    subItems: [
      {
        title: "Profile",
        path: "/dashboard/admin-settings/profile",
      },
      {
        title: "Account & Access",
        path: "/dashboard/admin-settings/account-access",
      },
      {
        title: "Feature Portfolio",
        path: "/dashboard/admin-settings/ddh_repository",
      },
      {
        title: "API Document",
        path: "/dashboard/admin-settings/docs",
      },
    ],
  },
];
